import { __decorate } from "tslib";
import { proxy, subscribe } from '@/infrastructure/object-reactive/object-reactive';
import { injectable } from '@/inversify.config';
let SpacePermissionModelImpl = class SpacePermissionModelImpl {
    constructor() {
        this._spacePermission = proxy(null);
    }
    get spacePermission() {
        return this._spacePermission.value;
    }
    updateSpacePermission(spacePermission) {
        this._spacePermission.value = {
            ...spacePermission,
        };
    }
    subscribeSpacePermission(callback) {
        const dispose = subscribe(() => this._spacePermission.value, (newVal) => {
            callback(newVal);
        });
        return dispose;
    }
};
SpacePermissionModelImpl = __decorate([
    injectable()
], SpacePermissionModelImpl);
export { SpacePermissionModelImpl };
